import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Profile } from '../model/profile.model';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class UserProfileService {

  constructor(private http: HttpClient) { }
  getProfile(){
    return this.http.get<Profile>(environment.apiConfig.uri + '/me')
  }
  getGroup() {
    return this.http.get<any>(environment.apiConfig.uri + '/me/transitiveMemberOf/microsoft.graph.group?$count=true')
  }


}
